import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewEncapsulation,
  AfterViewInit, OnDestroy
} from "@angular/core";

import { Router } from '@angular/router';
import { ADPResourceService as ResourceService } from "digital-core";
import { SalesService, CurrencyService } from "../../services";
import { NotificationService } from "digital-core";

import { UnderwritingStatus, Confirmation, SalesActivity, Program } from "../../models";
import { Subscription } from "rxjs";
import { ShareDataService, NavigationService } from "common/services";


@Component({
  selector: "gsp-confirmation-step",
  templateUrl: "./confirmation-step.component.html",
  styleUrls: ["./confirmation-step.component.css"],
  encapsulation: ViewEncapsulation.None,
})
export class ConfirmationStepComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() paymentFrequency: number;

  @Input()
  confirmation: Confirmation;

  @Input()
  isConnectedLivingFlow = true;

  @Output()
  confirmationNewApplicationEvent = new EventEmitter();

  sale: SalesActivity;
  showReferenceNumber: boolean;
  isActiveStep = false;
  selectedPlanName: string;
  referenceNumber: string;
  dateFormat: string;
  effectiveDateFormatted;
  policyReferenceNumber: string;
  showConfirmationStepTextDescription: boolean;
  showName: boolean;
  showAddress: boolean;
  showDescription: boolean;
  showPaymentFrequency: boolean;
  showRate: boolean;
  showPhoneNumber: boolean;
  showPrintReceiptPaymentmethod: string;
  showPdfReceiptBtn: any;
  showReferenceNumberURM: any;
  UnderwritingStatus = UnderwritingStatus;
  confirmationInternal: Confirmation;
  newApplicationSourceSubscription: Subscription;
  isAppeal: boolean;
  showDateOfBirth: boolean;

  constructor(private router: Router,
    public resourceService: ResourceService,
    private salesService: SalesService,
    private notificationService: NotificationService,
    private currencyService: CurrencyService,
    private navigationService: NavigationService,
    private shareDataService: ShareDataService) {

    // subscribe to (go to dashboard / new application) obserbable
    this.newApplicationSourceSubscription = this.navigationService.newApplicationSource.subscribe(
      result => {
        if (result) {
          this.newApplication();
        }
      });
  }

  ngOnInit() {
    this.showPdfReceiptBtn = JSON.parse(this.resourceService.getPortalSetting("Show_ReceiptBtn_ConfirmationSection").Value);
    this.showReferenceNumberURM = JSON.parse(this.resourceService.getPortalSetting("Show_ReferenceNumber_ConfirmationSectionURM").Value);
    this.showRate = JSON.parse(this.resourceService.getPortalSetting("Show_Rate_ConfirmationSection").Value);
    this.showPaymentFrequency = JSON.parse(this.resourceService.getPortalSetting("Show_PaymentFrequency_ConfirmationSection").Value);
    this.showDescription = JSON.parse(this.resourceService.getPortalSetting("Show_Description_ConfirmationSection").Value);
    this.showAddress = JSON.parse(this.resourceService.getPortalSetting("Show_Address_ConfirmationSection").Value);
    this.showName = JSON.parse(this.resourceService.getPortalSetting("Show_Name_ConfirmationSection").Value);
    this.showPhoneNumber = JSON.parse(this.resourceService.getPortalSetting("Show_PhoneNumber_ConfirmationSection").Value);
    this.showReferenceNumber = JSON.parse(this.resourceService.getPortalSetting("Show_ReferenceNumber_ConfirmationSection").Value);
    this.showDateOfBirth = JSON.parse(this.resourceService.getPortalSetting("Show_DateOfBirth_ConfirmationSection").Value);

    if (!!this.resourceService.getPortalSetting("Show_Receipt_PaymentMode")) {
      this.showPrintReceiptPaymentmethod = this.resourceService.getPortalSetting("Show_Receipt_PaymentMode").Value;
    }

    this.showConfirmationStepTextDescription = JSON.parse(this.resourceService.getPortalSetting("Show_ConfirmationStep_Text_Description").Value);

    // get the date format 
    this.dateFormat = this.resourceService.getPortalSetting('Client_DateFormat').Value;
    this.effectiveDateFormatted = this.resourceService.getFormattedDate(this.confirmation.EffectiveDate, this.dateFormat);
    this.sale = this.salesService.getSalesActivity();
    this.shareDataService.currentIsAppeal.subscribe(response => {

      if (response !== null && response !== undefined) {
        this.setAppeal(response);
      } else {
        this.setAppeal(false);
      }
    });
  }

  setAppeal(appeal) {
    this.isAppeal = appeal;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.selectedPlanName = this.confirmation
        ? this.confirmation.PlanName
        : "";
      this.referenceNumber = this.confirmation
        ? this.confirmation.ReferenceNumber
        : "";

      this.effectiveDateFormatted = this.confirmation
        ? this.resourceService.getFormattedDate(this.confirmation.EffectiveDate, this.dateFormat)
        : "";
    });
  }

  getReceiptDoc() {
    let pdfData: any;
    this.salesService.getReceiptDoc(this.sale)
      .subscribe(
        response => {
          let blob = new Blob([response], { type: 'application/pdf' });
          let fileURL = URL.createObjectURL(blob);
          window.open(fileURL, '_blank');
        },
        error => {
          this.notificationService.logError(error);
        }
      );
  }

  newApplication() {
    const IsRefreshApplicationSFValue = this.resourceService.getPortalSetting("IsRefreshApplication");
    const IsRefreshApplication = !!IsRefreshApplicationSFValue ? JSON.parse(IsRefreshApplicationSFValue.Value) : false;
    if (IsRefreshApplication) {
      window["skipPrompt"] = true;
      window.location.href = window.location.href;
    } else {
      this.confirmationNewApplicationEvent.emit(this);
    }
  }

  goToMembershipPage() {
    this.router.navigate(['/customers']);
  }

  currencyRate() {
    if (this.confirmation) {
      return this.currencyService.formatNumberCurrency(parseFloat(this.confirmation.Rate));
    }
  }

  formatDate() {
    if (this.confirmation) {
      return this.resourceService.getFormattedDate(this.confirmation.EffectiveDate, this.dateFormat);
    }
  }


  public setActiveStepFlag(active: boolean) {
    this.isActiveStep = active;
  }

  ngOnDestroy() {
    if (this.newApplicationSourceSubscription) {
      this.newApplicationSourceSubscription.unsubscribe();
    }
  }

  isAccProgram() {
    return this.confirmation.PreneedProgramType && this.confirmation.PreneedProgramType === Program.ACC;
  }

}
